import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../store';
import { sortProjectsByTimeframe } from '../lib/projects';
import ProjectCard from './ProjectCard';

export default function ProjectList() {
  const { projects, loading } = useAppData();
  const [showDone, setShowDone] = useState(false);

  if (loading) return <div className="loading-screen">Loading…</div>;

  const active = projects.filter((p) => p.status !== 'done');
  const done = projects.filter((p) => p.status === 'done');
  const sortedActive = sortProjectsByTimeframe(active);
  const sortedDone = sortProjectsByTimeframe(done);

  return (
    <div className="project-list">
      <div className="page-header">
        <h1>Projects</h1>
        <Link to="/projects/new" className="btn-primary">
          + Add project
        </Link>
      </div>

      {projects.length === 0 && (
        <p className="muted empty">
          No projects yet. Track the bigger, open-ended things — renovations, builds, anything
          without a fixed due date.
        </p>
      )}

      {sortedActive.length > 0 && (
        <div className="card-list">
          {sortedActive.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      )}

      {done.length > 0 && (
        <>
          <button
            type="button"
            className="btn-secondary small"
            onClick={() => setShowDone((s) => !s)}
          >
            {showDone ? 'Hide' : 'Show'} {done.length} done project{done.length === 1 ? '' : 's'}
          </button>

          {showDone && (
            <div className="card-list" style={{ marginTop: 10 }}>
              {sortedDone.map((project) => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
